import * as React from "react";
import { IReduxState } from "reducers";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import "./styles.scss";
import classnames from "classnames";
import {imageBaseUrl} from "config";
import {partnerOfferings} from "login/config";

interface IConnectProps {
  dispatch?: (action: any) => void;
  email: string;
  param: string;
  userId: number;
  utm_source: string;
  accessToken: string;
}
function AppBar(props: IConnectProps) {
  const classname = classnames("navbar navbar-default navbar-fixed-top navbar-light",
      { "center-logo": props.param === "sl" && !(props.email || props.userId) });
  return(
      <div id="app-bar-header" className={classname} style={{ background: `${props.email || props.userId ? "white" : "#F8F8F8"}`}}>
        {(props.email || props.userId)  ?
          partnerOfferings[props.utm_source] && partnerOfferings[props.utm_source]?.headerLogo  ?
            <div className="header-partner">
              <img
                className="partner-image"
                src={partnerOfferings[props.utm_source]?.headerLogo}
              />
              <span className="text-msl">Powered by <span className="color-orange">MyShubhLife</span></span>
            </div> :
            <img
              className="p-2"
              src={`${imageBaseUrl}/img/logo/logo-row.svg`}
              style={{ width: 175, margin: 8 }}
            />
          : <a href={imageBaseUrl}>
              <img className="p-2 app-bar-logo-left" src={`${imageBaseUrl}/img/logo/logo-row.svg`}/>
            </a>
        }
        {(props.email || props.userId) &&
        <div id="app-bar-right-section">
          {(!partnerOfferings[props.utm_source]) && <a href="https://mv343.app.goo.gl/mtck" target="_blank" className="googlePlayIcn">
            <img src={`${imageBaseUrl}/img/playstore-button/download-app-btn.jpg`}
                 style={{width: "125px"}}
                 alt="Download The App"/>
          </a>}
          {!props.accessToken ? <Link className={`btn logoutButton ${props.utm_source && props.utm_source.toLocaleLowerCase()}-btn`} to="/logout">
            Logout
          </Link> : null}
        </div>}
      </div>
  );
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
  return {
    email: state.login.auth ? state.login.auth.email : null,
    userId: state.login.auth ? state.login.auth.userId : null,
    param: state.userform.param,
    utm_source: state.login.authExt ? state.login.authExt.utm_source : null,
    accessToken: state.login.authExt && state.login.authExt.accessToken ? state.login.authExt.accessToken : null,
  };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(AppBar);
